import { MESSAGING_URL } from 'src/constants/constants';
import { cleanArray } from 'src/helpers';

const getMessageId = arr => {
  let res;
  arr.forEach((each, i) => {
    if (each === cleanArray(MESSAGING_URL.split('/'))[0]) {
      const next = i + 1;
      if (!isNaN(parseInt(arr[next], 10))) {
        res = parseInt(arr[next], 10);
      }
    }
  });
  return res;
};

export default getMessageId;



// WEBPACK FOOTER //
// ./src/helpers/getMessageId.js